import React from "react";
import AriaMessage from "../aria-message/AriaMessage";
import IconArrowLeft from "./icons/IconArrowLeft";
import { Container, Button } from "./styled/slider-prev";
function SliderPrev(_a) {
    var onClick = _a.onClick;
    return (React.createElement(Container, null,
        React.createElement(Button, { onClick: onClick },
            React.createElement(IconArrowLeft, null),
            React.createElement(AriaMessage, null, "Previous"))));
}
export default SliderPrev;
